<template>
  <div class="h-full overflow-hidden flex flex-col pt-3">
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      ref="tableDom"
    >
      <el-table-column
        fixed
        label="#"
        width="70"
        type="index"
        :index="
          (index) =>
            $buildTabIndex(state.params.page, state.params.limit, index)
        "
        align="center"
      />
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="状态" label2="申请人" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>{{ row.status_name }}</template>
            <template #bottom>
              <ul class="flex gap-x-2">
                <text class="text-gray-600">{{ row?.add_admin_name }} </text>
                <text>{{ row?.add_department_name }}</text>
              </ul>
              <text>{{ row?.create_time }} 申请</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column :width="300">
        <template #header>
          <div class="c-table-col-header" label1="付款单号" label2="收款信息" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <div
                class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
              >
                <strong>{{ row.number }}</strong>
              </div>
            </template>
            <template #bottom>
              <text v-if="row.is_supplier_purchase">
                {{
                  [
                    row.supplierBankAccount?.opening_bank,
                    row.supplierBankAccount?.name,
                    row.supplierBankAccount?.account,
                  ]
                    .filter((w) => w)
                    .join("-")
                }}
              </text>
              <text v-else>{{
                [row.opening_bank, row.bank_account_name, row.bank_account]
                  .filter((w) => w)
                  .join("-")
              }}</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="金额" label2="付款方式" />
        </template>
        <template #default="{ row }">
          <div class="flex gap-x-1">
            <c_money :value="row.amount" bold />
            <text class="text-xs text-gray-400">
              {{ row.d_payment_type_name }}
            </text>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="intro"
        label="申请说明"
        :formatter="$tab_TextFormat"
        :min-width="160"
      />
      <el-table-column
        label="附件"
        prop="remark"
        :formatter="$tab_TextFormat"
        :width="500"
      >
        <template #default="{ row }">
          <div
            class="flex flex-wrap gap-x-5 gap-y-2"
            v-if="row.attachment?.length > 0"
          >
            <text
              v-for="file in row.attachment"
              :key="item"
              class="hover:underline cursor-pointer text-green-700"
              @click="$openFile(file.file_url)"
            >
              {{ file.filename }}
            </text>
          </div>
          <text v-else>-</text>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" :width="260">
        <template #default="{ row }">
          <el-button
            type="primary"
            :icon="Money"
            link
            v-if="row.status === 1"
            @click.stop="
              state.selectId = row.id;
              state.showDetail = true;
            "
            >付款
          </el-button>
          <el-button
            type="success"
            :icon="Search"
            link
            @click.stop="
              state.selectId = row.id;
              state.showDetail = true;
            "
            v-else
            >查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.page"
      :pageSize="state.params.limit"
      @onLoad="
        (page) => {
          state.params.page = page.pageIndex;
          state.params.limit = page.pageSize;
          onLoad();
        }
      "
    />
  </div>
  <el-dialog
    v-model="state.showDetail"
    title="采购付款"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    style="width: 90%"
    append-to="#home_box"
  >
    <c_detail
      :id="state.selectId"
      @close="
        state.showDetail = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meetingpurchasepaymentapply_page } from "@/http/fukuanshenpi";

import c_detail from "./CaiGouFuKuanDetail";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_detail,
  },
  props: {
    params: Number,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.status = props.params?.status;
      state.params.keywords = props.params?.keywords;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      meetingpurchasepaymentapply_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    return { state, onLoad };
  },
};
</script>

<style lang="less" scoped></style>
